<template>
  <div v-if="!isConfirmationViewStep" class="qn-footer__container">
    <div class="d-flex" v-if="isInitialViewStep">
      <div class="flex-grow-1 text-left">
        <action-button
          class="btn-warning-outline outline-warning px-4 py-2"
          :text="$t('btCancel.Text')"
          i="far fa-times-circle"
          @click="$emit('cancel')"
        />
      </div>
      <div class="flex-grow-1 text-right">
        <action-button
          class="btn-success px-4 py-2"
          :text="$t('Begin')"
          iright="fa fa-arrow-alt-circle-right"
          @click="$emit('start')"
        />
      </div>
    </div>
    <div class="d-flex" v-else>
      <div class="flex-grow-1 text-left">
        <action-button
          class="btn-warning-outline outline-warning px-4 py-2"
          :text="$t('GoBack')"
          i="fa fa-arrow-circle-left"
          @click="$emit('prev')"
        />
      </div>
      <div v-if="!isFinishStep" class="flex-grow-1 text-right">
        <action-button
          class="btn-success px-4 py-2"
          :text="$t('btnContinue.Text')"
          iright="fa fa-arrow-alt-circle-right"
          @click="$emit('next')"
        />
      </div>
      <div v-if="isFinishStep" class="flex-grow-1 text-right">
        <action-button
          class="btn-success px-4"
          :text="$t('lblFinish')"
          i="far fa-check-circle"
          @click="$emit('finish')"
        />
      </div>
    </div>
  </div>
</template>

<script>
//libs
import ActionButton from 'ActionButton';

//constants
import requestFormSteps from '@/utils/constants/requestFormSteps.js';

export default {
  name: 'NavigationFooter',
  components: {
    ActionButton,
  },
  props: {
    currentStepId: {
      type: Number,
    },
    completeStepId: {
      type: Number,
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    hideFinishButton: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    firstStep() {
      return this.steps[0];
    },
    isFirstStep() {
      return this.firstStep?.id === this.currentStepId;
    },
    lastStep() {
      return this.firstStep?.id === this.currentStepId;
    },
    isCompleteStep() {
      return this.completeStepId
        ? this.currentStepId === this.completeStepId
        : this.currentStepId ===
            this.steps[this.steps.indexOf(this.lastStep) - 1]?.id;
    },
    isFinishStep() {
      return this.currentStepId === requestFormSteps.TERMS_AND_CONDITIONS;
    },
    isInitialViewStep() {
      return this.currentStepId === requestFormSteps.UNSET;
    },
    isConfirmationViewStep() {
      return this.currentStepId === requestFormSteps.REQUEST_CONFIRMATION;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
</style>
